// affiliates views
import Affiliates from '@/views/Affiliates.vue';
import AffiliateCard from '@/views/Affiliates/AffiliateCard.vue';

import AffiliatesList from '@/views/Affiliates/AffiliatesList.vue';
import AffiliatesNotifications from '@/views/Affiliates/AffiliatesNotifications.vue';

import AffiliateInfo from '@/views/Affiliates/Affiliate/AffiliateInfo.vue';
import AffiliateActivity from '@/views/Affiliates/Affiliate/AffiliateActivity.vue';
import BalanceHistory from '@/views/Affiliates/Affiliate/BalanceHistory.vue';
import AffiliateOffers from '@/views/Affiliates/Affiliate/AffiliateOffersNew.vue';
import AffiliateBonuses from '@/views/Affiliates/Affiliate/AffiliateBonuses.vue';
import AffiliatePromoCodes from '@/views/Affiliates/Affiliate/AffiliatePromoCodes.vue';
import AffiliateKpiBonuses from '@/views/Affiliates/Affiliate/AffiliateKpiBonuses.vue';
import EstimatedPayment from '@/views/Affiliates/Affiliate/EstimatedPayment.vue';
import AffiliatePayments from '@/views/Affiliates/Affiliate/AffiliatePayments.vue';
import AffiliateSub from '@/views/Affiliates/Affiliate/AffiliateSub.vue';
import DedicatedDomains from '@/views/Affiliates/Affiliate/DedicatedDomains.vue';

import AffiliatesReview from '@/views/Affiliates/AffiliatesReview.vue';
import OffersCategories from '@/views/Affiliates/Offers/OffersCategories.vue';
import OfferInfo from '@/views/Affiliates/Offers/OfferInfo.vue';

import AffiliatesMonitored from '@/views/Affiliates/AffiliatesMonitored.vue';

export default [
  {
    path: '/affiliates',
    component: Affiliates,
    meta: {
      requiresAuth: true,
      defaultLink: true,
      view: 'affiliates',
    },
    children: [
      {
        path: 'list',
        component: AffiliatesList,
        name: 'affiliates.list',
        meta: {
          view: 'list',
        },
      },
      {
        path: 'review',
        component: AffiliatesReview,
        name: 'affiliates.review',
        meta: {
          view: 'review',
        },
      },
      {
        path: 'offers',
        name: 'offers',
        component: OffersCategories,
        meta: {
          view: 'offers',
        },
        children: [
          {
            path: 'all',
            component: OfferInfo,
            name: 'all',
            meta: {
              view: 'offersList',
            },
          },
          {
            path: ':id',
            component: OfferInfo,
            name: ':id',
            meta: {
              view: 'offersList',
            },
          },
          {
            path: '',
            redirect: 'all',
          },
          {
            path: '*',
            redirect: 'all',
          },
        ],
      },
      {
        path: 'monitored',
        component: AffiliatesMonitored,
        name: 'monitored',
        meta: {
          view: 'monitored',
        },
      },
      {
        path: 'kpi-bonus',
        component: AffiliateKpiBonuses,
        name: 'affiliates.kpi-bonus',
        meta: {
          view: 'kpi-bonus',
        },
      },
      {
        path: 'notification',
        component: AffiliatesNotifications,
        name: 'affiliates.notification',
        meta: {
          view: 'notification',
        },
      },
      {
        path: ':id',
        component: AffiliateCard,
        children: [
          {
            path: 'info',
            name: 'affiliates.item.info',
            component: AffiliateInfo,
            meta: {
              view: 'info',
            },
          },
          {
            path: 'activity',
            component: AffiliateActivity,
            name: 'affiliates.item.activity',
            meta: {
              view: 'info',
            },
          },
          {
            path: 'balance-history/:wallet_id',
            name: 'affiliates.item.balance-history',
            component: BalanceHistory,
            meta: {
              view: 'info',
            },
          },
          {
            path: 'offers',
            name: 'affiliates.item.offers',
            component: AffiliateOffers,
            meta: {
              view: 'offers',
            },
          },
          {
            path: 'kpi-bonus/:account_status',
            name: 'affiliates.item.kpi-bonus',
            component: AffiliateKpiBonuses,
            meta: {
              view: 'kpi-bonus',
            },
          },
          {
            path: 'bonuses',
            component: AffiliateBonuses,
            name: 'affiliates.item.bonuses',
            meta: {
              view: 'bonuses',
            },
          },
          {
            path: 'promo-codes',
            component: AffiliatePromoCodes,
            name: 'affiliates.item.promocodes',
            meta: {
              view: 'promocodes',
            },
          },
          {
            path: 'payments-reports',
            component: EstimatedPayment,
            name: 'affiliates.item.estpayment',
            meta: {
              view: 'estpayment',
            },
          },
          {
            path: 'payments-history',
            component: AffiliatePayments,
            name: 'affiliates.item.payments-history',
            meta: {
              view: 'payments',
            },
          },
          {
            path: 'sub-affiliates',
            component: AffiliateSub,
            name: 'affiliates.item.sub-affiliates',
            meta: {
              view: 'sub',
            },
          },
          {
            path: 'dedication-domains',
            component: DedicatedDomains,
            name: 'affiliates.item.dedication-domains',
            meta: {
              view: 'dedication',
            },
          },
        ],
      },
      {
        path: '',
        name: 'affiliates.empty',
        redirect: {
          name: 'affiliates.list',
        },
      },
      {
        path: ':catchAll(.*)',
        name: 'affiliates.catch-all',
        redirect: {
          name: 'affiliates.list',
        },
      },
    ],
  },
];
